import Highcharts from 'highcharts'

/**
 * Fontes e espaçamento usados só na cópia exportada.
 * 8px é o rótulo do eixo X da Série Histórica na tela.
 */
export function exportReadabilityOptions(chart: Highcharts.Chart): Highcharts.Options {
    const axes = chart.options.xAxis
    const first = Array.isArray(axes) ? axes[0] : axes
    const size = first?.labels?.style?.fontSize
    const xAxisLabelFont = size === '8px' ? '14.72px' : '15.36px'
    const xAxisLabels: Highcharts.XAxisLabelsOptions = {
        style: {
            fontSize: xAxisLabelFont,
        },
    }

    /* Só a Série Histórica, identificada pelos 8px da tela. O mês permanece. */
    if (size === '8px')
        xAxisLabels.format = '{value:%b/%y}'

    return {
        chart: {
            spacingBottom: 2,
        },
        title: {
            style: {
                fontSize: '20px',
            },
        },
        legend: {
            margin: 4,
            itemStyle: {
                fontSize: '14.72px',
                textOverflow: 'none',
            },
        },
        xAxis: {
            labels: xAxisLabels,
        },
        yAxis: {
            title: {
                style: {
                    fontSize: '14.72px',
                },
            },
        },
    }
}
